import counterUp from 'counterup2';
require('waypoints/lib/jquery.waypoints');

$('.counterup').each((i, el) => {
    $(el).waypoint({
        handler: function() {
            counterUp(el, {
                duration: 1000,
            });
            this.destroy();
        },
        offset: 'bottom-in-view',
    });
});
